import { L2RButton, L2RCheckbox, styled } from "@l2r-front/l2r-ui"

export const Container = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(0, 8),
    gap: theme.spacing(2),
}))

export const SubNetworksContainer = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
    overflowY: "auto",
}))

export const Checkbox = styled(L2RCheckbox)({
    "&.MuiFormControlLabel-root": {
        margin: 0,
        justifyContent: "space-between",
    },
})

export const ButtonsContainer = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    alignSelf: "stretch",
    gap: theme.spacing(3),
    paddingTop: theme.spacing(4),
}))

export const Button = styled(L2RButton)({
    flex: 1,
})